import { isMatch, useMatches } from "@tanstack/react-router";

import { usePageActions } from "@/providers/hooks/use-page-actions";
import { usePageFilters } from "@/providers/hooks/use-page-filters";

import { Breadcrumbs } from "./breadcrumbs";
import { PageActionsSlot, PageToolbarTimeSlot } from "./page-actions";
import { PageFiltersToggle } from "./page-filters-toggle";

export function PageToolbar() {
    const matches = useMatches();
    const { filtersEnabled, filtersOpen, openFilters } = usePageFilters();
    const { actionCount, timeCount } = usePageActions();

    const isPending = matches.some((match) => match.status === "pending");
    const hasCrumbs = !isPending && matches.some((match) => isMatch(match, "staticData.config.breadcrumb"));
    const hasActions = actionCount > 0;
    const hasTime = timeCount > 0;

    if (!hasCrumbs && !filtersEnabled && !hasActions && !hasTime) {
        return null;
    }

    return (
        <div className="flex shrink-0 flex-wrap items-center justify-between gap-2">
            <div className="min-w-0">{hasCrumbs ? <Breadcrumbs /> : null}</div>
            <div className="ml-auto flex shrink-0 items-center gap-2">
                {filtersEnabled ? <PageFiltersToggle isOpen={filtersOpen} onOpen={openFilters} /> : null}
                <PageToolbarTimeSlot />
                <PageActionsSlot />
            </div>
        </div>
    );
}
